export enum TemplateVariableType {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  MONEY = 'MONEY',
  LIST = 'LIST',
  HTML = 'HTML',
}

export interface TemplateVariableDefinitionDto {
  key: string;
  translationKey: string;
  type: TemplateVariableType;
  exampleValue: string;
  /**
   * Whether the template body must output this variable as `{{ key }}`.
   * Mirrors the backend `@TemplateField(required=true)` — the backend rejects
   * a save whose body is missing any required variable.
   */
  required: boolean;
}
